<template>
  <div class="open">
    <div class="open-top">
      <van-nav-bar
        left-text="返回"
        right-text="清空"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
      >
        <slot slot="left" name="left">
          <van-icon name="arrow-left" />
        </slot>
      </van-nav-bar>
      <div class="apply-type-tabs">
        <Tab :selected="applyType" :tabList="getApplyTypes" :handleChange="handleApplyTypeChange"></Tab>
      </div>
      <div class="hr"></div>
    </div>
    <div class="content">
      <div class="hint" v-show="proxyFlag">
        <span class="iconfont">{{'\ue6e2'}}</span><span>税盘暂不支持开具此类发票，请切换发票类型</span>
      </div>
      <div class="hint-occupied" v-show="proxyFlag">
      </div>
      <div class="open-content">
        <div class="invoice-type-tabs" v-if="applyType === '2'">
          <Tab
            :selected="tabsValue"
            :tabList="getInvoiceTypes"
            :handleChange="handleTabsClick"
            background-color="#FFFFFF"
            title-active-color="#3378FF"
            title-inactive-color="#9EA9B9"
            :is-blue-line="true"
          ></Tab>
        </div>
        <div class="sell">
          <p class="sell-name">销方名称</p>
          <div class="change-sell-company">
            <OnlyChangeCompany :companyShow='true'></OnlyChangeCompany>
          </div>
        </div>
      <InvoiceTemplateImport
        v-if="applyType === '1'"
        :key="`template-import-${importContextKey}`"
        ref="templateImport"
        v-model="batchImport"
        :templates="templateList"
        :templateLoading="templateLoading"
        :templateError="templateError"
        :disabled="importSubmitting || importAccepted"
        @retry-templates="loadTemplates"
        @uploading-change="importUploading = $event"
        @view-imports="handleTemplateSubmitted"
      />
      <div v-if="applyType === '1' && importTask.status" :class="['import-task-result', `status-${importTask.status}`]">
        <div class="import-task-title">
          <van-loading v-if="importTask.status === 'processing'" size="18px" />
          <van-icon v-else :name="importTask.status === 'success' ? 'passed' : 'warning-o'" />
          <strong>{{ importTaskTitle }}</strong>
        </div>
        <p>{{ importTask.message }}</p>
        <div class="import-task-actions" v-if="importTask.status !== 'processing'">
          <button v-if="importTask.exceptionOssKey" type="button" @click="downloadImportErrors">下载错误明细</button>
          <button v-if="importRequestAccepted" type="button" @click="handleTemplateSubmitted">查看申请列表</button>
          <button v-if="importRequestAccepted" type="button" @click="startNewTemplateImport">继续导入</button>
        </div>
      </div>
      <div class="buy" v-if="applyType === '2'">
      <div :class="['customer-wrap',formData.purchaserName ? 'color' : '']">
        <FormList
          v-if="![7, 8].includes(Number(this.formData.invoiceType))"
          :list="formList"
          :data="formData"
          :onChange="onInputChange"
          :onBlur="onBlur"
          :onFocus="onFocus"
        />
        <FormList
          v-else
          :list="tabsValue === 7 ? allElectricUniversalFormList : allElectricFormList"
          :data="formData"
          :onChange="onInputChange"
          :onBlur="onBlur"
          :onFocus="onFocus"
        >
          <template slot="personLogoFlag">
            <van-checkbox :value="!!formData.personLogo" icon-size="14px" shape="square" @click="changePersonLogo">自然人</van-checkbox>
          </template>
          <template slot="purchaserShowFlag">
            <van-checkbox :value="!!formData.purchaserShowFlag" icon-size="14px" shape="square" @click="changepurchaserShowFlag">是否展示</van-checkbox>
          </template>
          <template slot="purchaserAddrShowFlag">
            <van-checkbox :value="!!formData.purchaserAddrShowFlag" icon-size="14px" shape="square" @click="changepurchaserAddrShowFlag">是否展示</van-checkbox>
          </template>
        </FormList>
        <div class="rollup" v-if="showTakerList && formalinvoiceList.length > 0">
          <div
            @click="onSelectCompany(item)"
            class="rollup-item"
            v-for="(item, index) in formalinvoiceList"
            :key="index"
          >
            <div class="rollup-company">
              <div>{{ item.company }}</div>
              <div v-if="item && item.managementBuyerFlag === 1">已添加</div>
            </div>
          </div>
          <div
            @click="showTakerList = false"
            class="rollup-item"
          >
            <div class="rollup-company">
              <div>关闭</div>
            </div>
          </div>
        </div>
      </div>
      </div>
        <div class="specific-business-selector" v-if="applyType === '2' && isSpecificBusinessInvoice">
          <InputField
            type="select"
            :value="formData.elementCode"
            label="特定业务"
            placeholder="请选择"
            :align="'right'"
            :options="specificBusinessOptions"
            :render="renderSpecificBusiness"
            @oninputchange="handleSpecificBusinessChange"
          />
        </div>
        <div class="goods-message" v-if="applyType === '2'">
          <div class="top">
            <div>商品明细 ({{goodsMeassage ? goodsMeassage.length : '0' }}) <span class="slash">|</span> <span class="add-good"  @click="addCommodity">{{ goodsMeassage && goodsMeassage.length ? '继续添加' : '添加商品'}}</span></div>
            <div class="taxIncluded">
              <div :class="isTax === 0 ? 'taxCheck' : ''" @click="changeIsTax(0)">含税</div>
              <div :class="isTax === 1 ? 'taxCheck' : ''" @click="changeIsTax(1)">不含税</div>
            </div>
          </div>
          <transition-group name="list">
          <!-- 计算逻辑 -->
          <div class="list-complete-div" v-for="(item,index) in goodsMeassage" :key="item.Id">
            <div class="goods-name">
              <span>{{ item.shortName ? '*' + (item.shortName.split('*').join('')) + '*' + item.goodsName : item.goodsName }}</span>
              <span class="huisuiyunfont" @click="handleDelete(item,index)">{{'\ue61c'}}</span>
            </div>
            <div class="goods-field-labels">
              <label :for="`goods-price-${index}`">单价</label>
              <label :for="`goods-quantity-${index}`">数量</label>
              <label :for="`goods-total-${index}`">总价</label>
            </div>
            <div class="bottom" v-if="isTax === 0">
              <div class="money">
                <input :id="`goods-price-${index}`" type="text" :value="item.price" placeholder="请输入单价" @blur="handleInput($event, item, index, 'price')">
              </div>
              <div class="length">
                <input :id="`goods-quantity-${index}`" type="text" :value="`${item.quantity}`" @blur="handleInput($event, item, index, 'quantity')" placeholder="请输入数量">
              </div>
              <div class="sum">
                <input :id="`goods-total-${index}`" type="text" :value="item.amountWithTax" @blur="handleInput($event, item, index, 'amountWithTax')" placeholder="请输入总价">
              </div>
            </div>
            <div class="bottom" v-else>
              <div class="money">
                  <input :id="`goods-price-${index}`" type="text" :value="item.unitPrice" @blur="handleTaxInput($event, item, index, 'unitPrice')" placeholder="请输入单价" >
              </div>
              <div class="length">
                <input :id="`goods-quantity-${index}`" type="text" :value="item.quantity" @blur="handleInput($event, item, index, 'quantity')" placeholder="请输入数量">
              </div>
              <div class="sum">
                <input :id="`goods-total-${index}`" type="text" :value="item.amount" @blur="handleTaxInput($event, item, index, 'amount')" placeholder="请输入总价">
              </div>
            </div>
            <div class="footer">
              <div>
                <input type="text" :value="item.specification" placeholder="请输入商品规格" @input="handleInput($event, item, index, 'specification')" @focus="handleSpecificationFocus(item,index)">
              </div>
              <div>
                <InputField
                  v-if="formData.elementCode === '01'"
                  type="select"
                  :value="item.unit"
                  placeholder="请选择"
                  :align="'right'"
                  :options="finishedOilOptions"
                  @oninputchange="(e) => handleInput({ target: { value: e }}, item, index, 'unit')"
                />
                <input v-else type="text" :value="item.unit" placeholder="请输入商品单位" @input="handleInput($event, item, index, 'unit')">
              </div>
            </div>
          </div>
          </transition-group>
          <div class="add-commodity">
            <div class="add-commodity-button" @click="addCommodity">
              {{ goodsMeassage && goodsMeassage.length ? '继续添加' : '添加商品' }}
            </div>
          </div>
        </div>
        <div
          class="specific-business-content"
          v-if="applyType === '2' && isSpecificBusinessInvoice && formData.elementCode && formData.elementCode !== '01'"
        >
          <SpecificBusiness
            ref="specific-business"
            :elementCode="formData.elementCode"
            :data="formData.specificElementVOs || []"
            :useCache="false"
          />
        </div>
        <div class="reception-way" v-if="applyType === '2'">
          <p>接收方式</p>
          <div class="send-way" v-if="formData.invoiceType === '1' || formData.invoiceType === '2' ">
            <div :class=" changeSend.changeYesSend ? 'change-send-color' : '' " @click="handleChangeSend('changeYesSend','1')" v-if="proxyFlag === false">快递寄送</div>
            <!-- <div :class=" changeSend.changeOneself ? 'change-send-color' : '' " @click="handleChangeSend('changeOneself','0')">税局自取</div> -->
            <div :class=" changeSend.changeNoSend ? 'change-send-color' : '' " @click="handleChangeSend('changeNoSend','')">无需寄送</div>
          </div>
          <div class="send-way email-none" v-else>
            <div :class=" changeEmailSend.changeEmail ? 'change-send-color' : '' " @click="handleChangeEmailSend('changeEmail','2')">邮箱发送</div>
            <div :class=" changeEmailSend.changeNoSend ? 'change-send-color' : '' " @click="handleChangeEmailSend('changeNoSend','')">无需寄送</div>
          </div>
          <div v-if="formData.logisticsFlag === '1' && proxyFlag === false">
            <van-row>
                <van-col span="24">
                  <div :class="['get-person',formData.receiverName ? 'color' : '']">
                    <InputField
                    type="text"
                    placeholder="填写收件人"
                    :value="formData.receiverName"
                    label="收件人"
                    @oninputchange="($event) => onInputChange({e: $event, field: 'receiverName'})"
                  />
                  </div>
                </van-col>
              </van-row>
              <div :class="['receiver-wrap',formData.receiverAddress ? 'color' : ''] ">
                <FormList
                  :list="formCustomerList"
                  :data="formData"
                  :onChange="onInputChange"
                />
              </div>
          </div>
          <div v-if="formData.logisticsFlag === '2' ">
            <div class="email">
            <FormList
              :list="formEmailList"
              :data="formData"
              :onChange="onInputChange"
            />
            </div>
          </div>
        </div>
        <div v-if="applyType === '2'" class="other-content">
          <p class="other-content-title">其他内容</p>
          <div class="leave-a-message">
            <div :class="formData.notes ? 'notes-color' : '' ">所在部门</div>
            <div @click="changeDeptVisible()">
              <input style="background: #fff" type="text" readOnly placeholder="请选择所在部门" v-model="formData.deptName"/>
            </div>
          </div>
          <!-- 扩展字段 -->
          <div :class="['customer-wrap',formData.notes ? 'color' : '' ]">
            <ExtendedFields :formData="formData" :onChange="onInputChange" />
          </div>
          <div class="leave-a-message">
            <div :class="formData.notes ? 'notes-color' : '' ">说明注释</div>
            <div>
              <input type="text" placeholder="填写说明注释" v-model="formData.notes"/>
            </div>
          </div>
          <OnlyChangeDept :hide='true' :visible="deptVisible" :deptInfo="{deptId: formData.deptId, deptName: formData.deptName}" @onCloseDeptPopup="onCloseDeptPopup"  @onSelectDept="onSelectDept"></OnlyChangeDept>
          <div class="upload">
            <p>上传附件</p>
            <p class="annex-explain">每张单据最多上传9个附件且附件大小不超过100M</p>
            <!-- 102400 -->
            <InputField
              type="file"
              :fileList="formData.files"
              :maxCount="9"
              :multiple="true"
              :fileSize="102400"
              accept="image/*,.pdf,.zip,.doc,.docx,.ppt,.txt,.xls,.xlsx,.ofd"
              @oninputchange="($event) => onInputChange({e: $event, field:'files'})"
              @finishUpload="finishUploadFile"
              @beforeDelete="deletePic"
            />
          </div>
        </div>
      </div>
      <div class="open-footer">
        <div v-if="applyType === '1'" class="batch-submit-footer">
          <van-button
            type="info"
            block
            :loading="importSubmitting"
            :disabled="importUploading || templateLoading || importAccepted"
            loading-text="提交中..."
            @click="submitTemplate"
          >提交申请</van-button>
        </div>
        <MakeOutAnInvoice
          v-else
          :footerContent="footerContent"
          @look="preview"
          :proxyFlag="proxyFlag"
          :title="isTax ? '合计不含税金额' : '合计含税金额'"
        />
      </div>
    </div>
    <transition name="fade">
    <div class="changer-specification" v-show="show">
      <div class="changer-specification-box">
        <div class="goods-name">
          <div>{{goodsItem.goodsName ? goodsItem.goodsName : '--'}}</div>
          <div class="iconfont" @click="handleClosePopup">{{'\ue607'}}</div>
        </div>
        <div class="goods-specification">
          <van-field
            v-model="goodsItem.specification"
            rows="3"
            autosize
            ref="textarea"
            type="textarea"
            maxlength="80"
            @focus="handle"
            placeholder="请输入规格"
            show-word-limit
          />
        </div>
        <div class="affirm">
          <div class="specification-edit" @click="handleAffirm">确认</div>
        </div>
      </div>
    </div>
    </transition>
     <van-popup
      v-model="showTaxRateWarning"
      :close-on-click-overlay="false"
    >
      <div class="showBlankInvoice-wrp">
        <div class="showBlankInvoiceClose">
          <span class="pc-header-title-content">提示</span>
          <i @click="showTaxRateWarning = false" class="huixiaopiaofont">&#xe632;</i>
        </div>
        <div class="showBlankInvoice-content" style="flex-direction: column">
          <span class="taxplatemsg" v-for="(item, key) in taxRateWarningText" :key="key" style="margin-bottom: 10px">{{item}}</span>
        </div>
        <div class="submit-btn-wrp">
          <van-button
            loading-type="spinner"
            class="submit-btn"
            type="info"
            @click="showTaxRateWarning = false"
            >取消
          </van-button>
          <van-button
            loading-type="spinner"
            class="submit-btn"
            type="info"
            v-if="showContinue"
            @click="taxRateResolve();showTaxRateWarning = false"
            >继续操作
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { invoiceRequest } from '@services'
import {
  ConvertNumber,
  onCount,
  deepCopy,
  debounce,
  subMixStr,
  localStorage,
  isEmail,
  isEmpty,
  stringGbkLength,
  NumFormat,
  testGoods,
  onCheckTaxRate,
  cutOutNumber,
  isAllElectric,
  isUniversalTicket,
  CheckBusinessMainInfo,
  autoMontageLookUp,
  removeSpace
} from '@utils/basicUtil'
import { NavBar, Icon, Notify, Row, Col, Field, Popup, Button, Tabs, Checkbox, Loading } from 'vant'
import OnlyChangeCompany from '@/components/OnlyChangeCompany'
import ExtendedFields from '@/components/ExtendedFields'
import OnlyChangeDept from '@/components/OnlyChangeDept'
import MakeOutAnInvoice from '@/components/MakeOutAnInvoice'
import SpecificBusiness from '@/components/SpecificBusiness'
import InvoiceTemplateImport from '@/components/InvoiceTemplateImport'
import InputField from '@/components/InputField'
import Tab from '@/components/Tab/index.vue'
import FormList from '@components/FormList'
import Observer from '@utils/observer'
import { InvoiceCal } from '@/utils/invoiceCal'
import {
  INVOICE_APPLY_IMPORT_BUSINESS_TYPE,
  INVOICE_APPLY_IMPORT_SOURCE,
  buildInvoiceBatchImportPayload,
  downloadImportErrorFile
} from '@/services/InvoiceBatchImportService'
import {
  INVOICE_TYPE,
  GET_TYPE,
  APPLICATION_INVOICE_TYPE_LIST,
  SPECIFIC_BUSINESS_OPTIONS,
  FINISHED_OIL,
  APPLY_TYPE
} from '@assets/config'

const createBatchImport = () => ({
  templateId: '',
  fileName: '',
  originalFileName: '',
  fileDirectory: ''
})

const createImportTask = () => ({
  status: '',
  message: '',
  exceptionOssKey: ''
})

const IMPORT_TASK_FUNCTION_NAME = 'AGENT_SETTLEMENT_IMPORT'
const IMPORT_POLL_INTERVAL = 2000
const IMPORT_POLL_LIMIT = 90
const wait = delay => new Promise(resolve => setTimeout(resolve, delay))

export default {
  data () {
    return {
      allTicketTypes: ['1', '2', '3', '4', '7', '8'],
      isTax: 0,
      invoiceLimits: '',
      itemIndex: 0,
      showGoods: '',
      applyType: (this.$route.query.editId || this.$route.query.showGoods) ? '2' : (localStorage.get('invoiceApplyType') || '2'),
      batchImport: createBatchImport(),
      importTask: createImportTask(),
      importUploading: false,
      importSubmitting: false,
      importRequestAccepted: false,
      importPollToken: 0,
      importContextKey: 0,
      templateList: [],
      templateLoading: false,
      templateError: '',
      templateRequestId: 0,
      tabsValue: 7,
      show: false,
      goodsItem: {},
      proxyFlag: false,
      goodsMeassage: [],
      deleteTransiton: true,
      changeSend: {
        changeYesSend: true,
        changeNoSend: false,
        changeOneself: false
      },
      changeEmailSend: {
        changeEmail: true,
        changeNoSend: false
      },
      typeShow: {
        expertShow: true,
        generalShow: false,
        electricityExpertShow: false,
        electricityGeneralShow: false
      },
      footerContent: {
        title: '合计不含税金额',
        money: 0.00,
        buttonTitle: '预览'
      },
      nowInvoiceType: '1',
      showCustomerDetail: true,
      showReceiverDetail: true,
      formalinvoiceListLoading: false,
      formEmailList: [
        {
          type: 'text',
          field: 'receiverEmail',
          placeholder: '填写邮箱地址',
          label: '邮箱',
          required: true
        },
        {
          type: 'text',
          field: 'purchaserPhone',
          placeholder: '填写手机号',
          label: '手机号'
        }
      ],
      formList: [
        {
          type: 'text',
          field: 'purchaserName',
          label: '购方名称',
          placeholder: '填写购方名称',
          maxlength: 50
        },
        {
          type: 'text',
          field: 'purchaserTaxNo',
          placeholder: '填写购方税号',
          label: '购方税号'
        },
        {
          type: 'text',
          field: 'purchaserAddress',
          placeholder: '填写地址、电话',
          label: '地址、电话'
        },
        {
          type: 'text',
          field: 'purchaserBankName',
          placeholder: '填写开户行及账号',
          label: '开户行及账号'
        },
        {
          type: 'text',
          field: 'remark',
          placeholder: '填写备注信息（非必填）',
          label: '备注'
        }
      ],
      allElectricUniversalFormList: [
        {
          type: 'text',
          field: 'purchaserName',
          label: '购方名称',
          placeholder: '填写购方名称',
          maxlength: 50,
          slot: 'personLogoFlag'
        },
        {
          type: 'text',
          field: 'purchaserTaxNo',
          placeholder: '填写购方税号',
          label: '购方税号'
        },
        {
          type: 'text',
          field: 'purchaserAddress',
          placeholder: '填写购买方地址',
          label: '地址'
        },
        {
          type: 'text',
          field: 'purchaserTel',
          placeholder: '填写电话',
          label: '电话',
          slot: 'purchaserAddrShowFlag'
        },
        {
          type: 'text',
          field: 'purchaserBankName',
          placeholder: '填写开户行',
          label: '开户行'
        },
        {
          type: 'text',
          field: 'purchaserBankAccount',
          placeholder: '填写银行账号',
          label: '账号',
          slot: 'purchaserShowFlag'
        },
        {
          type: 'text',
          field: 'remark',
          placeholder: '填写备注信息（非必填）',
          label: '备注',
          maxlength: 200
        }
      ],
      allElectricFormList: [
        {
          type: 'text',
          field: 'purchaserName',
          label: '购方名称',
          placeholder: '填写购方名称',
          maxlength: 50
        },
        {
          type: 'text',
          field: 'purchaserTaxNo',
          placeholder: '填写购方税号',
          label: '购方税号'
        },
        {
          type: 'text',
          field: 'purchaserAddress',
          placeholder: '填写购买方地址',
          label: '地址'
        },
        {
          type: 'text',
          field: 'purchaserTel',
          placeholder: '填写电话',
          label: '电话',
          slot: 'purchaserAddrShowFlag'
        },
        {
          type: 'text',
          field: 'purchaserBankName',
          placeholder: '填写开户行',
          label: '开户行'
        },
        {
          type: 'text',
          field: 'purchaserBankAccount',
          placeholder: '填写银行账号',
          label: '账号',
          slot: 'purchaserShowFlag'
        },
        {
          type: 'text',
          field: 'remark',
          placeholder: '填写备注信息（非必填）',
          label: '备注',
          maxlength: 200
        }
      ],
      formCustomerList: [
        {
          type: 'text',
          field: 'receiverAddress',
          placeholder: '填写收件地址',
          label: '收件地址'
        },
        {
          type: 'text',
          field: 'receiverPhone',
          placeholder: '填写收件人电话',
          label: '收件人电话'
        }
      ],
      logisticsList: [
        {
          type: 'radio',
          field: 'logisticsFlag',
          label: '接收方式',
          options: [ GET_TYPE[0], GET_TYPE[1] ]
        }
      ],
      formalinvoiceList: [],
      moneyIptShow: false,
      showTakerList: false,
      isClearData: true, // 返回时，是否清空缓存数据
      showTaxRateWarning: false, // 税率警告提示框
      taxRateWarningText: [],
      taxRateResolve: () => {},
      showContinue: true,
      deptVisible: false
    }
  },
  methods: {
    handleApplyTypeChange (value) {
      if (value === this.applyType) return

      this.$store.commit('invoice/initApplyData')
      this.$store.commit('invoice/changeGoodsList', [])
      sessionStorage.clear()
      this.goodsMeassage = []
      this.importContextKey += 1
      this.resetImportForm()
      this.applyType = value
      localStorage.set('invoiceApplyType', value)
      if (value === '1' && !this.templateList.length && !this.templateLoading) {
        this.loadImportContext()
      }
    },
    loadImportContext () {
      return this.loadTemplates()
    },
    async loadTemplates () {
      const requestId = ++this.templateRequestId
      this.templateLoading = true
      this.templateError = ''
      try {
        const result = await invoiceRequest.batchImport.templatePage({
          businessType: INVOICE_APPLY_IMPORT_BUSINESS_TYPE,
          current: 1,
          size: 100
        })
        if (requestId !== this.templateRequestId) return
        if (!result.success) {
          this.templateList = []
          this.templateError = result.message || '导入模板加载失败'
          return
        }
        this.templateList = (result.result && result.result.records) || []
        const selectedExists = this.templateList.some(item => String(item.id) === String(this.batchImport.templateId))
        this.batchImport = {
          ...this.batchImport,
          templateId: selectedExists ? this.batchImport.templateId : ((this.templateList[0] && this.templateList[0].id) || '')
        }
      } catch (error) {
        if (requestId === this.templateRequestId) {
          this.templateList = []
          this.templateError = error.message || '导入模板加载失败'
        }
      } finally {
        if (requestId === this.templateRequestId) {
          this.templateLoading = false
        }
      }
    },
    getSelectedImportTemplate () {
      return this.templateList.find(item => String(item.id) === String(this.batchImport.templateId)) || null
    },
    buildImportPayload () {
      return buildInvoiceBatchImportPayload(this.getSelectedImportTemplate(), this.batchImport)
    },
    async submitTemplate () {
      if (this.importSubmitting || this.importUploading || this.importAccepted) return
      if (!this.getSelectedImportTemplate()) {
        return Notify({ type: 'warning', message: '请选择导入模板' })
      }
      if (!this.batchImport.fileName || !this.batchImport.fileDirectory) {
        return Notify({ type: 'warning', message: '请上传开票Excel' })
      }

      this.importSubmitting = true
      const pollToken = ++this.importPollToken
      let parseAccepted = false
      this.importTask = {
        status: 'processing',
        message: '文件已上传，正在解析并创建开票申请...',
        exceptionOssKey: ''
      }
      try {
        const result = await invoiceRequest.batchImport.parse(this.buildImportPayload())
        if (!result.success) {
          const submissionUncertain = result.statusCode === 600 || result.statusCode >= 500
          this.importRequestAccepted = submissionUncertain
          this.importTask = {
            status: submissionUncertain ? 'submitted' : 'failed',
            message: submissionUncertain
              ? '网络异常，无法确认导入任务状态。请先到申请列表核对，避免重复提交同一文件'
              : (result.message || '批量导入提交失败'),
            exceptionOssKey: ''
          }
          return Notify({ type: submissionUncertain ? 'warning' : 'danger', message: this.importTask.message })
        }
        parseAccepted = true
        this.importRequestAccepted = true
        await this.pollImportTask(this.batchImport.fileName, pollToken)
      } catch (error) {
        if (pollToken !== this.importPollToken) return
        this.importTask = {
          status: parseAccepted ? 'submitted' : 'failed',
          message: parseAccepted
            ? '导入任务已提交后台处理，但暂时无法查询任务进度，请稍后到申请列表查看结果'
            : (error.message || '批量导入请求失败，请稍后重试'),
          exceptionOssKey: ''
        }
        Notify({ type: parseAccepted ? 'warning' : 'danger', message: this.importTask.message })
      } finally {
        if (pollToken === this.importPollToken) {
          this.importSubmitting = false
        }
      }
    },
    async pollImportTask (fileName, pollToken) {
      for (let count = 0; count < IMPORT_POLL_LIMIT; count++) {
        if (pollToken !== this.importPollToken) return
        const result = await invoiceRequest.batchImport.taskPage({
          current: 1,
          size: 100,
          type: 0,
          functionName: IMPORT_TASK_FUNCTION_NAME
        })
        if (!result.success) {
          if (result.result && result.result.errorCode === '1021017127') {
            this.importTask = {
              status: 'submitted',
              message: '导入任务已提交后台处理，当前账号无法查询任务进度，请稍后到申请列表查看结果',
              exceptionOssKey: ''
            }
            Notify({ type: 'warning', message: this.importTask.message })
            return
          }
          this.importTask.message = result.message || '导入任务状态查询失败，正在重试...'
          await wait(IMPORT_POLL_INTERVAL)
          continue
        }

        const records = (result.result && result.result.records) || []
        const task = records.find(item => this.isCurrentImportTask(item, fileName))
        if (!task || task.status === 0 || task.status === 1) {
          await wait(IMPORT_POLL_INTERVAL)
          continue
        }

        if (task.status === 2) {
          this.importTask = {
            status: 'success',
            message: task.resultMsg || '批量开票申请处理完成',
            exceptionOssKey: task.exceptionOssKey || ''
          }
          this.$store.commit('user/changeRefreshStatistics', true)
          Notify({ type: 'success', message: '批量开票申请处理完成' })
        } else {
          this.importTask = {
            status: 'failed',
            message: task.resultMsg || '批量开票申请处理失败',
            exceptionOssKey: task.exceptionOssKey || ''
          }
          Notify({ type: 'danger', message: this.importTask.message })
        }
        return
      }
      this.importTask = {
        status: 'submitted',
        message: '导入任务仍在后台处理，请稍后到申请列表查看结果',
        exceptionOssKey: ''
      }
      Notify({ type: 'warning', message: this.importTask.message })
    },
    isCurrentImportTask (task, fileName) {
      try {
        const requestQuery = JSON.parse(task.requestQuery || '{}')
        return requestQuery.fileName === fileName &&
          requestQuery.extraParams &&
          requestQuery.extraParams.batchImportSource === INVOICE_APPLY_IMPORT_SOURCE
      } catch (error) {
        return false
      }
    },
    async downloadImportErrors () {
      try {
        await downloadImportErrorFile(this.importTask.exceptionOssKey)
      } catch (error) {
        Notify({ type: 'danger', message: error.message || '错误明细下载失败' })
      }
    },
    handleTemplateSubmitted () {
      this.$store.commit('user/changeRefreshStatistics', true)
      this.$store.commit('invoice/initApplyData')
      this.$store.commit('invoice/changeGoodsList', [])
      this.$store.commit('invoice/initInvoiceHomeApplySearch')
      sessionStorage.clear()
      this.isClearData = false
      this.$router.push('/invoice/invoice-home?active=0')
    },
    startNewTemplateImport () {
      this.importContextKey += 1
      this.resetImportForm()
    },
    handleTabsClick (value) {
      this.handleChangeType(value)
    },
    changeIsTax (type) {
      this.isTax = type
      let goods = this.goodsMeassage
      this.goodsMeassage = []
      this.goodsMeassage = goods
    },
    handle () {
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    handleAffirm () {
      this.show = false
      this.goodsItem = {}
      this.itemIndex = 0
    },
    handleClosePopup () {
      this.show = false
      this.goodsItem = {}
      this.itemIndex = 0
    },
    handleSpecificationFocus (item, index) {
      this.show = true
      this.goodsItem = item
      this.itemIndex = index
      setTimeout(() => {
        this.$refs.textarea.focus()
      })
    },
    changePersonLogo () {
      this.changeApply({
        personLogo: this.formData.personLogo ? 0 : 1
      })
    },
    changepurchaserShowFlag () {
      this.changeApply({
        purchaserShowFlag: this.formData.purchaserShowFlag ? 0 : 1
      })
    },
    changepurchaserAddrShowFlag () {
      this.changeApply({
        purchaserAddrShowFlag: this.formData.purchaserAddrShowFlag ? 0 : 1
      })
    },
    getLocalGoods () {
      if (sessionStorage.nowGoodsMessage) {
        this.goodsMeassage = JSON.parse(sessionStorage.nowGoodsMessage)
        var a = 0
        let Id = 0
        let arr = []
        arr = this.goodsMeassage.map((item) => {
          item.Id = Id++
          a += item.quantity * item.price
          item.price = Number(item.price) === 0 || !item.price ? '' : Number(item.price).toFixed(2)
          item.quantity = item.quantity || ''
          return item
        })
        this.goodsMeassage = [...arr]
        this.footerContent.money = a
      }
    },
    handleAddShop (item) {
      let newItem = item
      newItem.amount = Number(newItem.amountWithTax) === 0 ? '' : Number(Number(newItem.amountWithTax) / Number(1 + newItem.taxRate)).toFixed(2)
      newItem.unitPrice = Number(newItem.amount) === 0 ? '' : Number(Number(newItem.amount) / Number(newItem.quantity)).toFixed(2)
      newItem.amountWithTax = Number(newItem.amountWithTax) === 0 ? '' : newItem.amountWithTax
      newItem.taxSign = newItem.taxSign ? 1 : 0
      newItem.price = Number(newItem.price) === 0 ? '' : newItem.price
      let nowGoodsMessage = []
      if (sessionStorage.nowGoodsMessage) {
        nowGoodsMessage = JSON.parse(sessionStorage.nowGoodsMessage)
      }
      nowGoodsMessage.push(newItem)
      sessionStorage.nowGoodsMessage = JSON.stringify(nowGoodsMessage)
      this.getLocalGoods()
      if (this.$store.state.invoice.goodsList.length > 0) {
        for (var index = 0; index < this.$store.state.invoice.goodsList.length; index++) {
          if (this.$store.state.invoice.goodsList[index].goodsName === newItem.goodsName) {
            sessionStorage.goods = JSON.stringify(this.$store.state.invoice.goodsList)
            return
          }
        }
        this.$store.state.invoice.goodsList.push(newItem)
      } else {
        this.$store.state.invoice.goodsList.push(newItem)
      }
      sessionStorage.goods = JSON.stringify(this.$store.state.invoice.goodsList)
    },
    calcAmountWithTax (goods) {
      const {
        taxPre,
        taxSign,
        taxRate = 0,
        price,
        quantity = 1
      } = goods
      const calcTaxRate = onCount.add(1, taxRate)
      const tempAmountWithTax = onCount.mul(price, quantity)
      let amountWithTax
      if (taxPre === 1 && this.showTaxSign) {
        // 不免税且显示是否含税标示
        amountWithTax = onCount.mul(tempAmountWithTax, (taxSign ? 1 : calcTaxRate))
      }
      return (amountWithTax || tempAmountWithTax).toFixed(2)
    },
    async getGoodsList () {
      if (sessionStorage.nowGoodsMessage) return
      // 税编缺失，默认申请开票可以查出来，电票直开默认不查标示为business 存在就不查
      let existRevenueCode = ''
      const current = 1
      const size = 20
      // defaultFlag默认商品标识 1 为默认商品
      const data = await invoiceRequest.goods.getGoodsList({
        goodName: this.searchKey,
        defaultFlag: 1,
        existRevenueCode,
        current,
        size,
        status: 0
      })
      if (data.success) {
        const arr = deepCopy(data.result.records)
        const resArr = arr.map((v, i) => {
          // 免税政策   免税价格
          // 不免税政策 showTaxSign ？原价格 ：含税价格
          // 免税价格：含税标示 ？原价格 / （1+税率） ： 原价格
          // 含税价格：含税标示 ？原价格：原价格*（1+税率）
          const originPrice = v.price
          let resTaxSign = v.taxSign === 1
          let resPrice
          if (!this.showTaxSign && v.taxPre === 1 && !resTaxSign) {
            resTaxSign = true
            resPrice = onCount.mul(originPrice, onCount.add(1, v.taxRate))
          }
          const res = {
            ...v,
            select: false,
            quantity: 1,
            price: this.convertPrice(resPrice || originPrice),
            taxSign: resTaxSign
          }
          res.amountWithTax = this.calcAmountWithTax(res)
          return res
        })
        resArr.forEach(i => {
          this.handleAddShop(i)
        })
      }
    },
    handleInput (e, item, index, field) {
      let newItem = { ...item }
      let value = e.target.value
      newItem[field] = value
      let invoiceCal = new InvoiceCal({ data: { ...newItem, unitPriceWithTax: newItem.price }, invoiceType: this.formData.invoiceType })
      if (field === 'quantity') {
        if (this.isTax === 0) { // 当前在含税的这个界面
          invoiceCal.changeQuantityWithTax(!item.revenueCode)
        } else {
          invoiceCal.changeQuantity(!item.revenueCode)
        }
      }
      if (field === 'amountWithTax') {
        invoiceCal.changeAmountWithTax()
      }
      // 含税 unitPriceWithTax
      if (field === 'price') {
        invoiceCal.changeUnitPriceWithTax()
      }
      // 不含税 unitPrice
      if (field === 'unitPrice') {
        invoiceCal.changeUnitPrice()
      }
      if (field === 'amount') {
        invoiceCal.changeAmount()
      }
      newItem = { ...invoiceCal.getResult(), price: invoiceCal.getResult().unitPriceWithTax }
      if (!isAllElectric(this.formData.invoiceType)) {
        if (newItem.quantity && newItem.quantity.toString().length > 10) {
          const temp = cutOutNumber(newItem.quantity)
          newItem.quantity = temp
        }
        if (newItem.unitPrice && newItem.unitPrice.toString().length > 10) {
          const temp = cutOutNumber(newItem.unitPrice)
          newItem.unitPrice = temp
        }
        if (newItem.price && newItem.price.toString().length > 10) {
          const temp = cutOutNumber(newItem.price)
          newItem.price = temp
        }
      }
      if (field === 'quantity' && newItem.quantity === '') {
        newItem.amountWithTax = ''
        newItem.amount = ''
      }
      this.goodsMeassage.splice(index, 1, newItem)
      sessionStorage.nowGoodsMessage = JSON.stringify(this.goodsMeassage)
      sessionStorage.goods = JSON.stringify(this.goodsMeassage)
    },
    handleTaxInput (e, item, index, field) {
      let newItem = { ...item }
      let value = e.target.value
      newItem[field] = value
      let invoiceCal = new InvoiceCal({ data: { ...newItem, unitPriceWithTax: newItem.price }, invoiceType: this.formData.invoiceType })
      if (field === 'quantity') {
        if (this.isTax === 0) { // 当前在含税的这个界面
          invoiceCal.changeQuantityWithTax()
        } else {
          invoiceCal.changeQuantity()
        }
      }
      if (field === 'amountWithTax') {
        invoiceCal.changeAmountWithTax()
      }
      // 含税 unitPriceWithTax
      if (field === 'price') {
        invoiceCal.changeUnitPriceWithTax()
      }
      // 不含税 unitPrice
      if (field === 'unitPrice') {
        invoiceCal.changeUnitPrice()
      }
      if (field === 'amount') {
        invoiceCal.changeAmount()
      }
      newItem = { ...invoiceCal.getResult(), price: invoiceCal.getResult().unitPriceWithTax }
      if (field === 'quantity' && newItem.quantity === '') {
        newItem.amountWithTax = ''
        newItem.amount = ''
      }
      this.goodsMeassage.splice(index, 1, newItem)
      sessionStorage.nowGoodsMessage = JSON.stringify(this.goodsMeassage)
      sessionStorage.goods = JSON.stringify(this.goodsMeassage)
    },
    resetImportForm ({ keepTemplate = true } = {}) {
      if (this.$refs.templateImport) {
        this.$refs.templateImport.clearFile()
      }
      const templateId = keepTemplate ? this.batchImport.templateId : ''
      this.batchImport = {
        ...createBatchImport(),
        templateId
      }
      this.importPollToken += 1
      this.importTask = createImportTask()
      this.importUploading = false
      this.importSubmitting = false
      this.importRequestAccepted = false
    },
    onRefresh () {
      this.importContextKey += 1
      this.resetImportForm({ keepTemplate: false })
      this.templateList = []
      this.templateError = ''
      this.invoiceTypeOptions()
      sessionStorage.clear()
      this.goodsMeassage = []
      this.getGoodsList()
      if (this.applyType === '1') {
        this.loadImportContext()
      }
    },
    companyChangeRefresh () {
      if (window.location.pathname + window.location.search === '/invoice/add-apply') {
        this.onRefresh()
      }
    },
    handleDelete (item, index) {
      this.deleteTransiton = true
      this.goodsMeassage.splice(index, 1)
      sessionStorage.nowGoodsMessage = JSON.stringify(this.goodsMeassage)
      sessionStorage.goods = JSON.stringify(this.goodsMeassage)
    },
    onClickRight () {
      this.importContextKey += 1
      this.resetImportForm()
      this.goodsMeassage = []
      this.changeSend = {
        changeYesSend: true,
        changeNoSend: false,
        changeOneself: false
      }
      this.changeEmailSend = {
        changeEmail: true,
        changeNoSend: false
      }
      this.footerContent.money = '0.00'
      sessionStorage.clear()
      if (window.location.pathname !== '/invoice/info') {
        this.$store.commit('invoice/initApplyData')
      }
      this.$store.commit('invoice/changeGoodsList', [])
      switch (this.formData.invoiceType) {
        case '1':
          this.handleChangeType(7)
          break
        case '2':
          this.handleChangeType(2)
          break
        case '3':
          this.handleChangeType(3)
          break
        case '4':
          this.handleChangeType(4)
          break
        case '7':
          this.handleChangeType(7)
          break
        case '8':
          this.handleChangeType(8)
          break
        default:
          this.handleChangeType(7)
          break
      }
    },
    handleLook () {
    },
    handleChangeType (invoiceType) {
      if (!isUniversalTicket(invoiceType) || !isAllElectric(invoiceType)) {
        this.changeApply({
          personLogo: 0
        })
      }
      if (!isAllElectric(invoiceType)) {
        this.changeApply({
          purchaserShowFlag: 0,
          purchaserAddrShowFlag: 0,
          elementCode: '',
          specificElementVOs: []
        })
      }
      this.tabsValue = invoiceType ? Number(invoiceType) : 7
      this.nowInvoiceType = invoiceType + ''
      if (invoiceType === 1 || invoiceType === 2) {
        this.changeSend = {
          changeYesSend: true,
          changeNoSend: false,
          changeOneself: false
        }
        this.$store.state.invoice.formData.logisticsFlag = '1'
      } else {
        this.changeEmailSend = {
          changeEmail: true,
          changeNoSend: false
        }
        this.$store.state.invoice.formData.logisticsFlag = '2'
      }
      this.$store.state.invoice.formData.invoiceType = this.nowInvoiceType
      if (this.invoiceLimits) {
        if (this.invoiceLimits.indexOf(this.formData.invoiceType + '') !== -1) {
          this.proxyFlag = false
        } else {
          this.proxyFlag = true
        }
      }
    },
    addCommodity () {
      this.syncSpecificBusinessData()
      sessionStorage.formData = JSON.stringify(this.formData)
      this.$router.push('/invoice/goods-list')
    },
    handleSpecificBusinessChange (elementCode) {
      this.changeApply({
        elementCode,
        specificElementVOs: []
      })
    },
    renderSpecificBusiness (elementCode) {
      const option = SPECIFIC_BUSINESS_OPTIONS.find(item => item.value === elementCode)
      return option ? option.label : ''
    },
    syncSpecificBusinessData ({ validate = false } = {}) {
      if (!this.isSpecificBusinessInvoice || !this.formData.elementCode || this.formData.elementCode === '01') {
        this.changeApply({
          specificElementVOs: []
        })
        return true
      }
      const specificBusiness = this.$refs['specific-business']
      if (!specificBusiness) return true
      if (validate && !specificBusiness.handleCheck()) return false
      this.changeApply({
        specificElementVOs: deepCopy(specificBusiness.specificElementVOs)
      })
      return true
    },
    handleChangeEmailSend (sendWay, logisticsFlag) {
      this.changeEmailSend = {
        changeEmail: false,
        changeNoSend: false
      }
      this.changeEmailSend[sendWay] = true
      this.$store.state.invoice.formData.logisticsFlag = logisticsFlag
    },
    handleChangeSend (sendWay, logisticsFlag) {
      this.changeSend = {
        changeYesSend: false,
        changeNoSend: false,
        changeOneself: false
      }
      this.$store.state.invoice.formData.logisticsFlag = logisticsFlag
      this.changeSend[sendWay] = true
    },
    sliceStr (text, len) {
      if (text && text.length > len) {
        return text.slice(0, len) + '...'
      } else {
        return text
      }
    },
    convertPrice (price) {
      const priceStr = String(price)
      if (priceStr.length > 15) {
        return priceStr.substr(0, 15)
      }
      return price
    },
    moneyInputScroll (res) {
      window.$('.add-apply').scrollTop(res)
    },
    goBack () {
      this.$router.go(-1)
    },
    finishUploadFile (result) {
      if (result.code === '200') {
        let res = [
          ...this.formData.files
        ]
        if (res.length >= 9) {
          return
        }
        const target = {
          url: result.fileUrl,
          file: result.file
        }
        res.push(target)
        this.changeApply({
          files: res
        })
      } else {
        Notify({ type: 'danger', message: result.message })
      }
    },
    deletePic (file) {
      let res = this.formData.files.filter(item => item.url !== file.url)
      this.changeApply({
        files: res
      })
    },
    invoiceTypeOptions () {
      let invoiceLimit = localStorage.get('invoiceLimits')
      invoiceLimit = invoiceLimit.split(',').filter(i => this.allTicketTypes.includes(i)).join(',')
      if (!invoiceLimit) {
        Notify({ type: 'danger', message: '尚未维护开票信息，请前往智能财税平台补充信息~' })
        return this.$router.push('/')
      }
      const options = deepCopy(INVOICE_TYPE)
      const res = invoiceLimit.split(',')
      options.forEach(item => {
        item.noPermision = true
        res.forEach(j => {
          if (j === item.value) {
            item.noPermision = false
          }
        })
      })
      options.forEach(item => {
        if (item.noPermision) {
          item.onClick = () => {
            this.changeProxyFlag(1)
          }
        } else {
          item.onClick = () => {
            this.changeProxyFlag(0)
          }
        }
      })
      let resDefaultType
      if (!this.formData.invoiceType) {
        resDefaultType = options.find(item => item.noPermision === false).value
      } else {
        resDefaultType = this.formData.invoiceType
      }
      if (resDefaultType === '3' || resDefaultType === '4' || resDefaultType === '7' || resDefaultType === '8') {
        // 选择电票，更改领取方式：自取，不填写取票信息
        this.changeApply({
          logisticsFlag: '0',
          invoiceType: resDefaultType
        })
        this.logisticsList[0].options = [GET_TYPE[1]]
      } else {
        this.logisticsList[0].options = [GET_TYPE[0], GET_TYPE[1]]
        this.changeApply({
          invoiceType: resDefaultType
        })
      }
      this.formList[0].options = options
    },
    changeApply (params) {
      this.$store.commit('invoice/changeApplyData', {
        formData: params
      })
    },
    changeGoodsList (goodsList) {
      this.$store.commit('invoice/changeGoodsList', goodsList)
    },
    changeDeptVisible () {
      this.deptVisible = true
    },
    gotoReveiverList () {
      if (!this.merchantId) {
        return
      }
      this.isClearData = false
      this.$router.push({
        path: '/invoice/receiver-list',
        query: {
          merchantId: this.merchantId
        }
      })
    },
    clearAddress () {
      this.changeApply({
        receiverName: '',
        receiverAddress: '',
        receiverPhone: '',
        receiverEmail: ''
      })
    },
    async preview () {
      if (!this.syncSpecificBusinessData({ validate: true })) return
      const {
        invoiceType,
        purchaserName,
        purchaserTaxNo,
        purchaserAddress,
        purchaserBankName,
        notes,
        remark,
        receiverName,
        receiverAddress,
        receiverPhone,
        receiverEmail,
        money,
        logisticsFlag,
        purchaserPhone,
        deptName,
        purchaserTel,
        purchaserBankAccount
      } = this.formData
      sessionStorage.formData = JSON.stringify(this.formData)
      // 校验购销方主体信息
      try {
        const check = new CheckBusinessMainInfo({ invoiceType })
        check.purchaserName({ value: purchaserName })
        check.purchaserTaxNo({ value: purchaserTaxNo })
        check.purchaserAddress({ value: purchaserAddress })
        check.purchaserTel({ value: purchaserTel, required: false })
        check.purchaserBankName({ value: purchaserBankName })
        check.purchaserBankAccount({ value: purchaserBankAccount, required: false })
        check.remark({ value: remark })
        if ([7, 8].includes(Number(invoiceType))) {
          const check = new CheckBusinessMainInfo({})
          this.goodsMeassage.forEach(i => check.unitPriceWithTax(i.unitPriceWithTax))
          this.goodsMeassage.forEach(i => check.unitPrice(i.unitPrice))
          this.goodsMeassage.forEach(i => check.quantity(i.quantity))
        }
      } catch (error) {
        if (error.message) {
          Notify({ type: 'danger', message: error.message })
        }
        return
      }

      if (stringGbkLength(notes) > 200) {
        return Notify({ type: 'danger', message: '留言不能超过200个字符' })
      }
      if (!money) {
        return Notify({ type: 'danger', message: '请填写正确的开票金额' })
      }
      // 校验商品
      try {
        if (!testGoods({ list: this.goodsMeassage, invoiceType })) {
          return
        }
      } catch (error) {
      }

      const wrongPrice = this.goodsMeassage.filter((goods) => !goods.amountWithTax || goods.amountWithTax === '0' || goods.amountWithTax === '0.00' || goods.amountWithTax < 0)
      if (wrongPrice.length) {
        return Notify({ type: 'danger', message: '商品价格需大于0' })
      }
      var isDingtalk = navigator && /DingTalk/.test(navigator.userAgent)
      if (isDingtalk) {
        if (!deptName) {
          return Notify({ type: 'danger', message: '请选择部门' })
        }
      }
      if (logisticsFlag === '1') {
        if (!receiverName) {
          return Notify({ type: 'danger', message: '请填写收件人' })
        }
      }

      if ((invoiceType === '3' || invoiceType === '4' || invoiceType === '7' || invoiceType === '8') && logisticsFlag !== '') {
        // 电票，收件人和邮箱必填
        if (!purchaserPhone && !receiverEmail) {
          return Notify({ type: 'danger', message: '请输入邮箱或手机号' })
        }
        if (receiverEmail) {
          const emailList = receiverEmail.split(';').map(item => item.trim()).filter(Boolean)
          if (!emailList.length || emailList.some(item => !isEmail(item))) {
            return Notify({ type: 'danger', message: '邮箱格式不正确' })
          }
        }
      } else {
      // 专票和普票邮件信息可以为空，其他信息必填
        if (logisticsFlag === '1') {
          if (!receiverAddress) {
            return Notify({ type: 'danger', message: '请填写收件地址' })
          }
          if (!receiverPhone) {
            return Notify({ type: 'danger', message: '请填写收件电话' })
          }
        }
      }
      if (logisticsFlag === '1') {
        if (receiverEmail) {
          const emailList = receiverEmail.split(';').map(item => item.trim()).filter(Boolean)
          if (!emailList.length || emailList.some(item => !isEmail(item))) {
            return Notify({ type: 'danger', message: '邮箱格式不正确' })
          }
        }
      }

      // 扩展字段校验
      const extendRequiredList = (this.$store.state.user.extendField || []).filter(i => i.requiredFlag).map(i => i.interMapping)
      let extendFlag = false
      for (let index = 0; index < extendRequiredList.length; index++) {
        if (!this.formData[extendRequiredList[index]]) {
          extendFlag = true
          break
        }
      }
      if (extendFlag) return Notify({ type: 'danger', message: '请填写必填的扩展字段' })

      await this.onCheckTaxRate()
      await this.onCheckImmediateLevyRefund()
      this.isClearData = false
      if (!isUniversalTicket(invoiceType) || !isAllElectric(invoiceType)) {
        this.changeApply({
          personLogo: 0
        })
      }
      if (!isAllElectric(invoiceType)) {
        this.changeApply({
          purchaserShowFlag: 0,
          purchaserAddrShowFlag: 0
        })
      }
      if (this.$route.query.editId) {
        this.$router.push({
          path: `/invoice/detail?editId=${this.$route.query.editId}&sum=${this.footerContent.money}`
        })
      } else {
        let sum = 0
        this.goodsMeassage.forEach((item) => {
          if (!item.quantity && !item.price) {
            sum += item.amountWithTax ? Number(item.amountWithTax) : 0
          } else {
            sum += Number(item.quantity) * Number(item.price)
          }
        })
        this.$store.state.invoice.formData.money = Number(sum)
        this.$router.push({
          path: `/invoice/detail`,
          query: { sum: sum }
        })
      }
    },
    onCheckTaxRate () {
      // 添加小规模纳税人校验
      const arr = deepCopy(this.goodsMeassage)
      const invoiceType = this.formData.invoiceType
      const nature = this.companyInfo.type
      return new Promise(async (resolve) => {
        const result = await this.checkTaxRate.check({ nature, details: arr, invoiceType })
        if (result.length) {
          this.showTaxRateWarning = true
          this.showContinue = true
          this.taxRateWarningText = result
          this.taxRateResolve = resolve
        } else {
          resolve(true)
        }
      })
    },
    onCheckImmediateLevyRefund () {
      // 添加小规模纳税人校验
      const arr = deepCopy(this.goodsMeassage)
      return new Promise(async (resolve) => {
        const result = await this.checkTaxRate.checkImmediateLevyRefund({ details: arr })
        if (result.length) {
          this.showTaxRateWarning = true
          this.showContinue = false
          this.taxRateWarningText = result
          this.taxRateResolve = resolve
        } else {
          resolve(true)
        }
      })
    },
    gotoGoodsList () {
      this.isClearData = false
      this.$router.push('/invoice/goods-list')
    },
    onShowCustomerDetail () {
      this.showCustomerDetail = !this.showCustomerDetail
    },
    onShowReceiverDetail () {
      this.showReceiverDetail = !this.showReceiverDetail
    },
    onSearchTitle () {
      this.formalinvoiceList = []
      this.formalinvoiceListLoading = true
    },
    onSelectCompany (item) {
      const { address, bankName, company, taxNo, id, tel, bankNo, allEmail } = autoMontageLookUp(item, this.formData.invoiceType)
      this.changeApply({
        purchaserName: company,
        purchaserTaxNo: taxNo ? taxNo.toUpperCase() : taxNo,
        purchaserAddress: `${address || ''}`,
        purchaserBankName: `${bankName || ''}`,
        purchaserTel: `${tel || ''}`,
        purchaserBankAccount: `${bankNo || ''}`,
        receiverEmail: `${allEmail || ''}`,
        purchaserEmail: `${allEmail || ''}`
      })
      if (id) {
        this.$store.commit('invoice/changeMerchantId', id)
        this.getReceiver(id)
      }
      this.$store.commit('invoice/changeMerchantInfo', { ...item })
      this.formalinvoiceList = []
    },
    onSelectDept (item) {
      const { deptId, deptName } = item
      this.changeApply({
        deptId,
        deptName
      })
      this.$store.commit('invoice/changeDeptInfo', item)
    },
    changeProxyFlag (e) {
      if (e === 1) {
        // this.getDefaultTaker()
        this.changeApply({
          proxyFlag: e
        })
      } else {
        this.changeApply({
          taker: '',
          takerIdCard: '',
          takerTelephone: '',
          proxyFlag: e
        })
      }
    },
    onInputChange ({ e, field }) {
      if (field === 'invoiceType') {
        if (e === '3' || e === '4' || e === '7' || e === '8') {
        // 选择电票，更改领取方式：自取，不填写取票信息
          this.changeApply({
            logisticsFlag: '0'
          })
          this.logisticsList[0].options = [GET_TYPE[1]]
        } else {
          this.logisticsList[0].options = [GET_TYPE[0], GET_TYPE[1]]
        }
      }
      if (field === 'purchaserName') {
        this.showTakerList = true
        this.onSearch(e)
      }
      if (field === 'purchaserTaxNo') {
        e = e ? e.toUpperCase() : e
      }
      if (field === 'proxyFlag') {
        this.changeProxyFlag(e)
      }
      this.changeApply({
        [field]: removeSpace(e)
      })
    },
    onBlur ({ e, field }) {
      if (field === 'purchaserName') {
        this.testBuyerName(e)
      }
    },
    testBuyerName () {
      if (!this.formData.purchaserName.length) {
        return Notify({ type: 'danger', message: '请填写发票抬头' })
      } else {
        this.formData.purchaserName = subMixStr(this.formData.purchaserName, 100)
      }
    },
    onFocus ({ e, field }) {
      if (field === 'purchaserName') {
        this.showTakerList = true
      } else {
        this.showTakerList = false
      }
    },
    debounce: debounce((vm) => { vm.getCustomerListByName() }, 300),
    onSearch (value) {
      if (value.length >= 1) {
        this.debounce(this)
      }
    },
    convertNumber (data) {
      return ConvertNumber(data)
    },
    inputFocus () {
    },
    inputBlur () {
      if (!/^\d+$|^\d*\.\d+$/g.test(this.formData.money.trim())) {
        if (Number(this.formData.money) < 0) {
          this.changeApply({
            money: Math.abs(Number(this.formData.money)).toString()
          })
        } else {
          this.changeApply({
            money: ''
          })
          return Notify({ type: 'danger', message: '请输入正确的金额' })
        }
      }
      this.changeApply({
        money: this.formData.money.length > 0 ? Number(this.formData.money).toFixed(2) : this.formData.money = ''
      })
      this.moneyIptShow = false
      const list = deepCopy(this.goodsList)
      if (!(Array.isArray(list) && list.length === 0)) {
        this.equalMoney()
      }
    },
    clearMoney () {
      this.changeApply({
        money: 0
      })
    },
    moneyValueHandle () {
      if (this.formData.money === '0.00' || this.formData.money === '0' || this.formData.money === 0 || this.formData.money === 0.00) {
        this.changeApply({
          money: ''
        })
      }
      this.moneyIptShow = true
    },
    calcPriceOrQtyWithAmount (goods) {
      const {
        taxPre,
        taxSign,
        taxRate = 0,
        quantity,
        amountWithTax
      } = goods
      const calcTaxRate = onCount.add(1, taxRate)
      if (quantity) {
        const tempPrice = onCount.div(amountWithTax, quantity)
        let resPrice
        if (taxPre === 1 && this.showTaxSign && !taxSign) {
          // 不免税 && 显示是否含税标示 && 不含税标示
          resPrice = onCount.div(tempPrice, calcTaxRate)
        } else {
          resPrice = tempPrice
        }
        return resPrice
      }
    },
    equalMoney () {
      const arr = deepCopy(this.goodsList)
      let originalMoney = arr.reduce((sum, item) => sum + Number(item.amountWithTax), 0).toFixed(2)
      // 按照比例粗略计算
      const calcArr = arr.map((v, i) => {
        const originalGoodsItem = deepCopy(v)
        const calcRatio = onCount.div(Number(originalGoodsItem.amountWithTax), originalMoney).toFixed(4)
        return {
          ...originalGoodsItem,
          amountWithTax: onCount.mul(Number(this.formData.money), calcRatio).toFixed(2)
        }
      })
      const calcMoney = calcArr.reduce((sum, item) => sum + Number(item.amountWithTax), 0).toFixed(2)
      const calcResDiff = Number(onCount.sub(Number(this.formData.money), Number(calcMoney)))
      if (calcResDiff >= 0) {
        let lastGoods = calcArr[calcArr.length - 1]
        // 最后一项加上calcResDiff
        if (isEmpty(lastGoods.amountWithTax)) {
          lastGoods.amountWithTax = (Number(lastGoods.amountWithTax) + calcResDiff).toFixed(2)
        }
      } else {
        // 最大amount项减去calcResDiff
        let indexOfMaxGoods = 0
        // eslint-disable-next-line no-return-assign
        calcArr.reduce((a, c, i) => Number(c.amountWithTax) > a ? (indexOfMaxGoods = i, Number(c.amountWithTax)) : a, 0)
        // calcArr.reduce((a, c, i) => {
        //   return Number(c.amountWithTax) > a ? (indexOfMaxGoods = i, Number(c.amountWithTax)) : a
        // }, 0)
        calcArr[indexOfMaxGoods].amountWithTax = Number(onCount.add(Number(calcArr[indexOfMaxGoods].amountWithTax), calcResDiff)).toFixed(2)
      }

      const resGoodsList = calcArr.map((item) => {
        return {
          ...item,
          price: this.calcPriceOrQtyWithAmount(item) || null
        }
      })
      this.changeGoodsList(resGoodsList)
    },
    async getCustomerListByName () {
      this.$store.commit('invoice/initMerchantInfo')
      if (!this.formData.purchaserName) {
        return
      }
      const data = await invoiceRequest.customer.getCustomersByName({ companyName: this.formData.purchaserName })
      if (data.success) {
        if (data.result.length) {
          this.formalinvoiceList = data.result
        } else {
          this.formalinvoiceList = []
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async getReceiver (merchantId) {
      const data = await invoiceRequest.customer.getDefaultReceiver({ merchantId })
      if (data.success) {
        if (!data.result) {
          return
        }
        const {
          userName,
          address,
          telephone,
          email
        } = data.result
        this.changeApply({
          receiverName: userName,
          receiverAddress: address,
          receiverPhone: telephone,
          receiverEmail: email
        })
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async getDefaultTaker () {
      const data = await invoiceRequest.taker.getDefaultTaker({})
      if (data.success) {
        if (data.result) {
          const {
            taker,
            takerIdCard,
            takerTelephone
          } = data.result
          this.changeApply({
            taker,
            takerIdCard,
            takerTelephone
          })
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    onCloseDeptPopup () {
      this.deptVisible = false
    }
  },
  watch: {
    'formData.invoiceType' (v) {
      this.tabsValue = v ? Number(v) : 7
    },
    goodsMeassage (v) {
      var sum = 0
      v.forEach((item) => {
        if (this.isTax === 0) {
          if (!item.quantity && !item.price) {
            sum += item.amountWithTax
          } else {
            sum += item.quantity * item.price
          }
        } else {
          if (!item.quantity && !item.unitPrice) {
            sum += item.amount
          } else {
            sum += item.quantity * (item.unitPrice)
          }
        }
      })
      this.footerContent.money = sum
    }
  },
  created () {
    if (this.$route.query.showGoods) {
      if (!sessionStorage.showGoods) {
        this.showGoods = this.$route.query.showGoods
        sessionStorage.showGoods = this.showGoods
        this.$store.state.invoice.formData.details.forEach((item) => {
          item.amount = Number(item.amountWithTax) === 0 ? '' : Number(Number(item.amountWithTax) / Number(1 + item.taxRate)).toFixed(2)
          item.unitPrice = !item.quantity ? '' : Number(item.amount) === 0 ? '' : Number(Number(item.amount) / Number(item.quantity)).toFixed(2)
          item.price = !item.quantity ? '' : Number(item.amountWithTax) === 0 ? '' : Number(Number(item.amountWithTax) / Number(item.quantity)).toFixed(2)
          item.quantity = item.quantity || ''
          this.goodsMeassage.push(item)
        })
        sessionStorage.nowGoodsMessage = JSON.stringify(this.goodsMeassage)
        sessionStorage.goods = JSON.stringify(this.goodsMeassage)
      }
    }
  },
  async mounted () {
    let invoiceLimits = localStorage.get('invoiceLimits')
    this.invoiceLimits = invoiceLimits.split(',').filter(i => this.allTicketTypes.includes(i)).join(',')

    await this.getGoodsList()

    if (this.$route.query.showGoods) {
      if (!sessionStorage.showGoods) {
        this.showGoods = this.$route.query.showGoods
        sessionStorage.showGoods = this.showGoods
        this.$store.state.invoice.formData.details.forEach((item) => {
          item.amount = Number(item.amountWithTax) === 0 ? '' : Number(Number(item.amountWithTax) / Number(1 + item.taxRate)).toFixed(2)
          item.unitPrice = !item.quantity ? '' : Number(item.amount) === 0 ? '' : Number(Number(item.amount) / Number(item.quantity)).toFixed(2)
          item.price = !item.quantity ? '' : Number(item.amountWithTax) === 0 ? '' : Number(Number(item.amountWithTax) / Number(item.quantity)).toFixed(2)
          item.quantity = item.quantity || ''
          this.goodsMeassage.push(item)
        })
        sessionStorage.nowGoodsMessage = JSON.stringify(this.goodsMeassage)
        sessionStorage.goods = JSON.stringify(this.goodsMeassage)
      }
    }
    this.invoiceTypeOptions()
    if (sessionStorage.formData) {
      this.$store.state.invoice.formData = JSON.parse(sessionStorage.formData)
      if (this.$store.state.invoice.formData.proxyFlag === 1) {
        this.$store.state.invoice.formData.logisticsFlag = '0'
      } else {
        this.$store.state.invoice.formData.logisticsFlag = '1'
      }
    }
    if (this.applyType === '1') {
      await this.loadImportContext()
    }
    // 根据会话储存获取goods
    this.getLocalGoods()
    if (this.$store.state.invoice.formData.proxyFlag === 1) {
      this.proxyFlag = true
      this.changeSend.changeOneself = true
      this.$store.state.invoice.formData.logisticsFlag = '0'
    }
    Observer.setFunction({
      type: 'changeCompany',
      fn: this.companyChangeRefresh
    })
    Observer.setFunction({
      type: 'changeDept',
      fn: this.onSelectDept
    })
    switch (this.formData.invoiceType) {
      case '1':
        this.handleChangeType(1)
        break
      case '2':
        this.handleChangeType(2)
        break
      case '3':
        this.handleChangeType(3)
        break
      case '4':
        this.handleChangeType(4)
        break
      case '7':
        this.handleChangeType(7)
        break
      case '8':
        this.handleChangeType(8)
        break
      default:
        this.handleChangeType(1)
        break
    }
    // eslint-disable-next-line new-cap
    this.checkTaxRate = new onCheckTaxRate()
  },
  computed: {
    isSpecificBusinessInvoice () {
      return [7, 8].includes(Number(this.formData.invoiceType))
    },
    specificBusinessOptions () {
      return SPECIFIC_BUSINESS_OPTIONS.map(item => ({
        title: item.label,
        value: item.value
      }))
    },
    finishedOilOptions () {
      return FINISHED_OIL
    },
    getApplyTypes () {
      return APPLY_TYPE
    },
    importTaskTitle () {
      if (this.importTask.status === 'processing') return '正在处理'
      if (this.importTask.status === 'failed') return '处理失败'
      if (this.importTask.status === 'submitted') return '已提交'
      return this.importTask.exceptionOssKey ? '处理完成，存在失败数据' : '处理完成'
    },
    importAccepted () {
      return this.importRequestAccepted || this.importTask.status === 'processing'
    },
    getInvoiceTypes () {
      return APPLICATION_INVOICE_TYPE_LIST
    },
    setNum () {
      return function (money) {
        if (money === '' || money === null) {
          return '0.00'
        }
        let num = money + ''
        let arr = num.split('.')
        if (arr[1]) {
          return Number(arr[1]) < 10 ? Number(arr[1]) + '0' : num
        } else {
          return money + '.00'
        }
      }
    },
    merchantId () {
      return this.$store.state.invoice.merchantId
    },
    formData () {
      return this.$store.state.invoice.formData
    },
    goodsList () {
      return this.$store.state.invoice.goodsList
    },
    showTaxSign () {
      // 0 显示
      // 1 不显示。默认所有商品含税
      // 免税政策 也不显示
      return localStorage.get('showTaxSign') === '0'
    },
    companyInfo () {
      return this.$store.state.user.company
    },
    autoNumber () {
      return function (num) {
        return NumFormat(num)
      }
    }
  },
  beforeDestroy () {
    this.importPollToken += 1
    if (this.isClearData) {
      if (window.location.pathname !== '/invoice/info') {
        this.$store.commit('invoice/initApplyData')
      }
      this.$store.commit('invoice/changeGoodsList', [])
    }
  },
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Notify.name]: Notify,
    [Row.name]: Row,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Col.name]: Col,
    [Tabs.name]: Tabs,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Loading.name]: Loading,
    MakeOutAnInvoice,
    InvoiceTemplateImport,
    OnlyChangeCompany,
    OnlyChangeDept,
    ExtendedFields,
    SpecificBusiness,
    InputField,
    FormList,
    Tab
  }
}
</script>
<style lang="less" scoped src="./style.less"></style>
